import { h } from "preact";
import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "preact/hooks";
import { useDispatch } from "react-redux";

import Button from "../Button.jsx";
import ErrorState from "../ErrorState.jsx";
import HealthInsuranceChooser from "./HealthInsuranceChooser.jsx";
import Page from "../Page.jsx";

import { sendError } from "../../errors.js";
import i18n from "../../i18n.js";
import { setLoading } from "../../store/uiSlice.js";
import productApi from "../../api/products";
import taskApi from "../../api/task";

const PREDEFINED_CHOOSERS = {
  health_insurance: HealthInsuranceChooser,
};

export default function ProductChooser({
  productGroupId,
  onNext,
  onRestart,
  taskId,
}) {
  const navigate = useNavigate();
  const [products, setProducts] = useState([]);
  const [error, setError] = useState(null);
  const [loaded, setLoaded] = useState(false);
  const dispatch = useDispatch();

  async function selectProduct(event, productId) {
    event && event.preventDefault();
    await taskApi.selectResult(taskId, productId);
    onNext();
  }

  function handleBackToTasklist() {
    navigate("/tasks");
  }

  useEffect(async () => {
    dispatch(setLoading(true));
    try {
      setError(null);
      const data = await productApi.fetchGroup(productGroupId);
      setProducts(data.products);
    } catch (err) {
      sendError(err);
      // TODO: some handing is needed here
      setError(err);
    }
    setLoaded(true);
    dispatch(setLoading(false));
  }, []);

  if (!loaded) {
    return null;
  }

  if (error) {
    return (
      <div class="product-chooser">
        <ErrorState fullGrid>
          <div class="task-page__buttons">
            <Button onClick={handleBackToTasklist}>
              {i18n.t("actions.back_to_tasklist")}
            </Button>
            <Button text onClick={onRestart} class="mr-16">
              {i18n.t("actions.discard_result")}
            </Button>
          </div>
        </ErrorState>
      </div>
    );
  }

  if (products.length === 0) {
    // TODO: Define this sate
    return <div>No data</div>;
  }

  const SpecificChooser = PREDEFINED_CHOOSERS[productGroupId];

  return (
    <div class="product-chooser">
      {SpecificChooser ? (
        <SpecificChooser
          products={products}
          onSelect={(product) => selectProduct(null, product.id)}
        />
      ) : (
        <div class="mb-32">
          {products.map((product) => (
            <Page
              noAnswersNeeded
              chooser
              pageId={product.page}
              productId={product.id}
              product={product}
              onNext={(event) => selectProduct(event, product.id)}
            />
          ))}
        </div>
      )}
      <Button onClick={onNext}>{i18n.t("actions.enter_result")}</Button>
      <Button text onClick={onRestart}>
        {i18n.t("actions.discard_result")}
      </Button>
    </div>
  );
}
